import Signup from '@pages/signup/signup';
export default Signup;
